const Layout1Settings = {
  leftSidebar: {
    show: false,
    mode: "close", // full, close, compact, mobile,
    theme: "slateDark1", // View all valid theme colors inside MainTheme/themeColors.js
    bgImgURL: "/public/assets/images/sidebar/sidebar-bg-dark.jpg",
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "blueDark", // View all valid theme colors inside MainTheme/themeColors.js
  },
};

export default Layout1Settings;
